//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.FBM.Feature.js";
let d=[[[0,"CoordinateSystem",0,"CartesianCoordinateSystem",0],[0,"Name",1,0],[0,"SourceType",0,0],[0,"Status",0,0],[0,"Type",0,0],[0,"TypeDisplayName",0,0]],[[["num_faces"],"GetFaces",{R_:{faces:"Face[]"}},0,0],[["group"],"GetProcessStatus",{R_:{status:''}},1,0],[["num_groups"],"GetGroups",{R_:{groups:"CAM.NCGroup[]"}},0,0],[["num_operations"],"GetOperations",{R_:{operations:"CAM.Operation[]"}},0,0],[[],"ApproveChanges",{},0,0],[["num_entities"],"GetGeometry",{R_:{geometry:"DisplayableObject[]"}},0,0]],[["Attributes","CAM.CAMAttributeCollection",0]]];
SPLM.CAM.CAMFeature = class extends SPLM.CAM.FBM.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.CAMFeature";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.CAMFeature.State = Object.freeze({
    "Deleted" : "Deleted", "Changed" : "Changed", "Updated" : "Updated", "UpToDate" : "UpToDate"});

SPLM.CAM.CAMFeature.ProcessStatus = Object.freeze({
    "Empty" : "Empty", "Regenerate" : "Regenerate", "Incomplete" : "Incomplete", "Complete" : "Complete"});

export default SPLM;